export const COLOR_OK = 'success';
export const COLOR_KO = 'error';
export const COLOR_CANCELLED = 'default';
export const COLOR_ON_REITERATION = 'warning';